import React from "react";

// Keeping track of menu expansion
import { useSelector } from "react-redux";
import { selectMenuOpen } from "../../redux/features/applicationState/applicationStateSlice";

// Icons
import {
  DocumentCheckIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

const EntrySaveStatus = ({ entryChanged }) => {
  const isMenuOpen = useSelector(selectMenuOpen);
  const Icon = entryChanged ? ExclamationTriangleIcon : DocumentCheckIcon;

  const iconSize = isMenuOpen
    ? "h-7 w-7 lg:h-6 lg:w-6 xl:h-8 xl:w-8"
    : "h-7 w-7 xl:h-8 xl:w-8";

  const textSize = isMenuOpen
    ? "text-2xl lg:text-lg xl:text-2xl 2xl:text-3xl"
    : "text-2xl xl:text-3xl";

  return (
    <div
      className={`flex items-center justify-center w-full h-12 rounded-lg ${
        entryChanged ? "bg-rose-100" : "bg-green-100"
      }`}
    >
      <Icon
        className={`${iconSize} transition-all duration-200 ${
          entryChanged ? "text-rose-500" : "text-neutral-600"
        }`}
      />

      <i
        className={`ml-2 ${textSize} transition-all duration-200 ${
          entryChanged ? "text-rose-500" : "text-neutral-600"
        }`}
      >
        {entryChanged ? "Unsaved Changes!" : "All Changes Saved."}
      </i>
    </div>
  );
};

export default EntrySaveStatus;
